import {get} from "../../utilities/SimpleClient";

export const downloadInvoices = async (job) => {
    const invoiceDocuments = job.documents.filter((doc => doc.document.tags[0].documenttag.id === 9));
    const link = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);

   for (const document of invoiceDocuments) {
       try {
           const response = await get(document.document.file);
           if (!(response instanceof Blob) || response.size === 0) {
               console.error('Invalid file received:', document.document.filename);
               continue;
           }
           const blobUrl = window.URL.createObjectURL(response);

           link.href = blobUrl;
           link.download = document.document.filename || 'invoice.pdf';
           link.click();

           window.URL.revokeObjectURL(blobUrl);

       } catch (error) {
           console.error('Download failed for', document.document.filename, error);
       }

   }
}
